/** @jsxImportSource minimal-view */

import { chain, element, on, view, web } from 'minimal-view'
import { services } from './services'

export const Modal = web(view('modal',
  class props {
  },
  class local {
    host = element
    visible = false
    box?: HTMLDivElement
    contents: JSX.Element = false
  },
  function actions({ $, fns, fn }) {
    return fns(new class actions {

    })
  },
  function effects({ $, fx, deps, refs }) {
    services.fx(({ skin }) => {
      $.css = /*css*/`
      & {
        position: fixed;
        display: none;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        background: ${skin.colors.shadeDark};
      }

      &([visible]) {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: ${skin.fonts.sans};
      }

      .box {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 15px 20px 5px;
        background: ${skin.colors.bgLighter};
        font-family: ${skin.fonts.sans};
        font-size: 16px;
        overflow: hidden;

        width: 70%;
        max-width: 560px;

        height: 70%;
        min-height: 70%;
        max-height: 70%;

        ${skin.styles.raised}
      }

      h1 {
        text-align: center;
        padding: 0;
        margin: 0;
        font-weight: normal;
        font-size: 25px;
        font-family: ${skin.fonts.sans};
      }

      textarea {
        display: flex;
        flex: 1;
        width: 100%;
        color: ${skin.colors.fg};
        background: ${skin.colors.bg};
        font-family: ${skin.fonts.mono};
        border: none;
        overscroll-behavior: contain;

        ${skin.styles.lowered}
      }
      `
    })

    const stop = (e: any) => {
      if ($.visible) {
        const path = e.composedPath()

        if (e.type === 'pointermove') {
          e.stopImmediatePropagation()
        }

        if (e.type === 'pointerdown' && path[0] === $.host) {
          $.visible = false
        }
      }
    }

    fx(({ host, visible }) => {
      host.toggleAttribute('visible', visible)
    })

    fx(() =>
      chain(
        on(window, 'pointermove').capture(stop),
        on(window, 'pointerdown').capture(stop)
      )
    )

    fx(({ contents }) => {
      $.view = <div class="box" ref={refs.box}>
        {contents}
      </div>
    })
  }
))

export type Modal = typeof Modal.State
